const LANGUAGE_OPTIONS = [
  { value: 'ua', short: 'UA', label: 'Украинский' },
  { value: 'ru', short: 'RU', label: 'Русский' },
  { value: 'en', short: 'EN', label: 'Английский' },
];

const normalizeLanguageCode = (language) => {
  if (typeof language !== 'string') {
    return 'ua';
  }
  const normalized = language.trim().toLowerCase();
  return LANGUAGE_OPTIONS.some((option) => option.value === normalized) ? normalized : 'ua';
};

const getLanguageOption = (language) =>
  LANGUAGE_OPTIONS.find((option) => option.value === normalizeLanguageCode(language));

export const getLanguageLabel = (language) => getLanguageOption(language)?.label ?? 'Украинский';

export const getLanguageShortLabel = (language) => getLanguageOption(language)?.short ?? 'UA';

export const deckLanguageOptions = LANGUAGE_OPTIONS;

export default normalizeLanguageCode;
